<template>
  <div class="teacher-layout">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'TeacherLayout'
}
</script>

<style>
@import '@/common/less/teacher.less';
.teacher-layout {
  width: 100%;
  height: 100%;
}
</style>